import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UsersStore } from '@data-access/user/stores/users.store';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private userStore = inject(UsersStore);
  private router = inject(Router);

  canActivate(): boolean {
    if (this.userStore.user()) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;

  }
}
